export default "__VITE_ASSET__DRr72hxT__"